import module from 'app/module.js'
import template from './template.html'
import { isString } from 'lodash'
import './style.scss'

let historialKardex = null

const schema = {
  tipo: 'number',
  status: 'boolean',
}

class SearchboxComponent {
  resultados = null
  limite = null
  query = ''
  history = historialKardex
  buscando = false
  timeout = null
  tipo = ''

  constructor ($http, $q) {
    this.$http = $http
    this.$q = $q
  }

  $onInit () {
    this.$http.get('/buscador/historial/kardex', {schema})
      .then((response) => this.history = historialKardex = response.data)
  }

  buscar (limite = null) {
    let q = this.query.trim()
    let tipo

    if (q.indexOf(':') >= 0) {
      tipo = q.substring(0, q.indexOf(':')).trim().toLowerCase()
      q = q.substring(q.indexOf(':') + 1).trim()
    }

    if (!isString(q) || q.length < 3) return

    this.cancelar()
    this.timeout = this.$q.defer()
    this.limite = limite
    this.buscando = true
    this.tipo = tipo || ''

    return this.$http.get('/kendu/empleados/buscar', {
        params: {tipo, q, limite},
        timeout: this.timeout.promise,
        schema,
      })
      .then((response) => (this.resultados = response.data))
      .catch(() => this.resultados = [])
      .finally(() => this.buscando = false)
  }

  cancelar () {
    if (this.timeout) {
      this.timeout.resolve()
      this.timeout = null
    }
  }
}

module.component('searchbox', {
  controller: SearchboxComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/app/components/searchbox/component.js